<template>
  <div>
    <h1 class="page-header">{{ $t('reportPayrollNss.pageTitle') }}</h1>
    <div class="ts-flex ts--mx-4">
      <div class="ts-w-3/12 ts-px-4">
        <ts-card>
          <ts-card-wrapper>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group m-b-10">
                  <label class="col-form-label control-label">{{ $t('reportPayrollNss.orgChartStructure') }}</label>
                  <div>
                    <ts-select
                      v-model="model.org_chart_structure_id"
                      :options="
                        orgChartStructures.map(o => ({ value: o.org_chart_structure_id, text: o.org_chart_structure }))
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="ts-flex ts--mx-2">
              <div class="ts-w-1/2 ts-px-2">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group m-b-10">
                      <label class="col-form-label control-label">{{ $t('reportPayrollNss.cycleYear') }}</label>
                      <div>
                        <ts-year-picker-input v-model="model.cycle_year" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="ts-w-1/2 ts-px-2">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group m-b-10">
                      <label class="col-form-label control-label">{{ $t('reportPayrollNss.cycleMonth') }}</label>
                      <div>
                        <ts-month-picker-input v-model="model.cycle_month" format="M" displayFormat="MMM" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group m-b-10">
                  <label class="col-form-label control-label">{{ $t('reportPayrollNss.exchangeRate') }}</label>
                  <div>
                    <ts-input v-model="model.exchange_rate" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row ts-mt-4">
              <div class="col-sm-12 col-lg-12 col-md-12 ts-text-right">
                <ts-button outline color="primary" class="mr-2" @click="exportExcel" :waiting="exporting"
                  >Export</ts-button
                >
                <ts-button color="primary" @click="fetchData" :waiting="loading">View</ts-button>
              </div>
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="ts-w-9/12 ts-px-4">
        <ts-card>
          <div class="overflow-auto">
            <ts-table
              :columns="Object.keys(columns).length > 0 ? Object.values(columns).map(c => c[0]) : ['Report viewer']"
              :records="records"
              :loading="loading"
            >
              <template v-slot="{ record, index }">
                <td v-for="colName in Object.keys(columns)" :key="colName">{{ record[colName] }}</td>
              </template>
            </ts-table>
          </div>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce, trim, find } from 'lodash'
import { mapState } from 'vuex'
import * as FileDownload from 'downloadjs'
import { Errors } from 'form-backend-validation'

export default {
  name: 'report-payroll-nss',
  data() {
    return {
      model: {
        org_chart_structure_id: '',
        cycle_year: '',
        cycle_month: '',
        exchange_rate: ''
      },
      loading: false,
      exporting: false,
      errors: new Errors()
    }
  },
  computed: {
    ...mapState('hr/reportPayrollNss', ['orgChartStructures', 'records', 'columns']),
    search: {
      get() {
        return this.$store.state.hr.reportPayrollNss.search
      },
      set(newValue) {
        this.$store.commit('hr/reportPayrollNss/SET_SEARCH', newValue)
        this.$store.commit('hr/reportPayrollNss/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData() {
      this.loading = true
      this.$store
        .dispatch('hr/reportPayrollNss/fetch', this.model)
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },

    exportExcel() {
      this.exporting = true

      this.$store
        .dispatch('hr/reportPayrollNss/exportExcel', this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(response.headers['content-disposition'].indexOf('filename'))
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(err)))
          this.$toasted.error(error.message)
        })
        .finally(() => (this.exporting = false))
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('hr/reportPayrollNss/RESET_STATE')
    next()
  }
}
</script>
